import EmailStepOne from './Presentational/Email/emailStepOne';
import EmailStepTwo from './Presentational/Email/emailStepTwo';
import PhoneStepOne from './Presentational/Phone/phoneStepOne';
import PhoneStepTwo from './Presentational/Phone/phoneStepTwo';
import ConfirmationPopup from './Presentational/confirmationPopup';
import classes from './twoFactorAuthContainer.scss';
import { getLocalizedStrings } from './twoFactorAuthenticationStrings';
import FocusTrap from 'focus-trap-react';

class TwoFactorAuthContainer extends React.Component {
  constructor(props) {
    super(props);
    this.strings = getLocalizedStrings('twoFactorAuthenticationStrings');
    this.state = {
      currentStep: "stepOne", typeOfAuth: '', sendCodeResponse: '',
      userEnteredValue: this.props.twoFactorAuthentication.userEnteredValue, disableVerifyBtn: true, verifyPin: '',
      phoneType: { validStyle: '', outlineStyle: '', value: this.props.twoFactorAuthentication.changeFlag === "V" ? this.props.twoFactorAuthentication.phoneTypeSelectionEdit : this.strings.mobile, labels: [this.strings.mobile, this.strings.landline] },
      resendSuccess: true, resendExceedMsg: '',invalidCodeError: false,disableSendCodeBtn:false,
    };
    this.RESEND_COUNTER = 0;
    this.TEXT_EMAIL_PIN = 6;
    this.CALL_PIN = 5;
    this.MAX_RESEND_LIMIT = 10;
    this.RESEND_DISABLE_TIME = 30 * 60 * 1000;
    this.closeIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Close.svg';
  }
  /* Handles web analytics for send code functionality */
  webAnalyticsSendCode = (typeOfAuth) => {
    switch (typeOfAuth) {
        case "email":
            window.aUtils.sendAAEvent("button", "continue");
            break;
        case "sms":
            window.aUtils.sendAAEvent("button", "textMe");
            break;
        /* Sonar Cube fix 
          Done by : Keerthi VL
          Date : 23-01-2023
      */
        default: window.aUtils.sendAAEvent("button", "callMe");
    }
}
  /* Handles send code functionality */
  sendCodeHandler = (typeOfAuth) => {
    this.setState({disableSendCodeBtn:true,typeOfAuth: typeOfAuth});
    this.webAnalyticsSendCode(typeOfAuth);
    const factors = this.props.factors ? true : false;
    app.profileSettingsService.twoFactorAuthSendResendVerifyCode(typeOfAuth, this.state.userEnteredValue, this.props.twoFactorAuthentication.encryptedvalue, this.state.sendCodeResponse,factors).then(
      (response) => {
        if (response.sendPinstatus === 'Success') {
          this.setState({ currentStep: 'stepTwo', sendCodeResponse: response,disableSendCodeBtn:false });       
        }
      }, (error) => {
        this.setState({ currentStep: 'stepOne' ,disableSendCodeBtn:false});
      }
    );
  }
  /* Handles verify pin functionality */
  verifyCodeHandler = () => {
    this.setState({disableVerifyBtn:true});
    window.aUtils.sendAAEvent("button","verify");
    /* Sonar Cube fix 
          Done by : Keerthi VL
          Date : 23-01-2023
      */
    let requestObj = { factorType: this.state.typeOfAuth, value: this.state.userEnteredValue, passcode: this.state.verifyPin, sendCodeResponse: this.state.sendCodeResponse, addressGuid: this.props.addressGuid,
                   contactType:  this.props.twoFactorAuthentication.changeFlag === "U" ? this.props.twoFactorAuthentication.phoneTypeSelectionEdit : this.state.phoneType.value,
                   changeFlag:this.props.twoFactorAuthentication.changeFlag === "V" && this.props.twoFactorAuthentication.phoneTypeSelectionEdit !== this.state.phoneType.value ? "U" : this.props.twoFactorAuthentication.changeFlag,
                   encryptedvalue: this.props.twoFactorAuthentication.encryptedvalue, sequenceNum: this.props.twoFactorAuthentication.seqNo, bpNumber:this.props.twoFactorAuthentication.bpNumber, factors: this.props.factors ? true : false
                    };
    app.profileSettingsService.twoFactorAuthVerifyPin(requestObj, this.props.twoFactorAuthentication.duplicateNumber).then(
      (response) => {
        if ((response.factorstatus === 'Success') && (response.saPstatus === 'Success')) {
          this.setState({ currentStep: 'stepThree',invalidCodeError: false });
          this.props.refreshNotification();
        }
        else{
          this.setState({invalidCodeError: true});
        }
      }, (error) => {
        this.setState({ currentStep: 'stepTwo' });
      }
    );
  }
  /* Handles resend code functionality */
  resendCodeHandler = () => {
    if (this.RESEND_COUNTER < this.MAX_RESEND_LIMIT) {
      const factors = this.props.factors ? true : false;
      app.profileSettingsService.twoFactorAuthSendResendVerifyCode(this.state.typeOfAuth, this.state.userEnteredValue, this.props.twoFactorAuthentication.encryptedvalue, this.state.sendCodeResponse, factors).then(
        response => {
          if (response.sendPinstatus === 'Success') {
            this.setState({ resendSuccess: true, invalidCodeError: false });
          }
          else{
            this.setState({ resendSuccess: false, invalidCodeError: false });
          }
        },
        error => {
          this.setState({ resendSuccess: false, invalidCodeError: false });
        });
      this.RESEND_COUNTER++;

    }
    else {
      this.setState({ resendExceedMsg: this.strings.limitExceedErrorMsg, invalidCodeError: false,resendSuccess:true });
      setTimeout(() => this.setState({ resendExceedMsg: "" }), this.RESEND_DISABLE_TIME);//enable resend link after 30 mins
      this.RESEND_COUNTER=0;
    }
  }
  /* updates the phone type whether mobile or landline */
  phoneTypeHandler = (event) => {
    const updatedState = { ...this.state };
    updatedState.phoneType.value = event.currentTarget.value;
    this.setState(updatedState);
  }
  /* updates the pin entered and calls enable verify btn function */
  onChangeHandler = (pin) => {
    const updatedState = { ...this.state };
    updatedState.verifyPin = pin, updatedState.invalidCodeError = false;
    this.setState(updatedState,
      () => { this.enableVerifyBtn(); });
  }
  /* Enables the verify button based on the text me and call me button */
  enableVerifyBtn = () => {
    const verifyPinLength = this.state.typeOfAuth === "call" ? this.CALL_PIN : this.TEXT_EMAIL_PIN;
    const updatedState = { ...this.state };
    if (verifyPinLength === this.state.verifyPin.length) {
      updatedState.disableVerifyBtn = false;
      this.setState(updatedState);
    }
    else {
      updatedState.disableVerifyBtn = true;
      this.setState(updatedState);
    }
  }
  /* Assists to navigate email 2FA screens */
  getToEmailView = () => {
    switch (this.state.currentStep) {
      case "stepTwo":
        return <EmailStepTwo userEnteredValue={this.props.twoFactorAuthentication.userEnteredValue} formatEmailIdWithStar={this.props.formatEmailIdWithStar} textEmailPinLength={this.TEXT_EMAIL_PIN} resendCodeHandler={this.resendCodeHandler} disableVerifyBtn={this.state.disableVerifyBtn} verifyCodeHandler={this.verifyCodeHandler}
         onChangeHandler={this.onChangeHandler} invalidCodeError={this.state.invalidCodeError} resendExceedMsg={this.state.resendExceedMsg} resendSuccess={this.state.resendSuccess} />;
      case "stepThree":
        return <ConfirmationPopup isEmail={this.props.twoFactorAuthentication.isEmail} handleCloseClick={this.props.handleCloseClick} />;
      /* Sonar Cube fix 
          Done by : Keerthi VL
          Date : 23-01-2023
      */
      default:
        return <EmailStepOne userEnteredValue={this.props.twoFactorAuthentication.userEnteredValue} formatEmailIdWithStar={this.props.formatEmailIdWithStar} sendCodeHandler={this.sendCodeHandler} disableSendCodeBtn={this.state.disableSendCodeBtn} />;
    }
  };
  /* Assists to navigate phone 2FA screens */
  getToPhoneView = () => {
    switch (this.state.currentStep) {
      case "stepTwo":
        return <PhoneStepTwo callPinLength={this.CALL_PIN} textEmailPinLength={this.TEXT_EMAIL_PIN} typeOfAuth={this.state.typeOfAuth} disableVerifyBtn={this.state.disableVerifyBtn} onChangeHandler={this.onChangeHandler} resendExceedMsg={this.state.resendExceedMsg} resendSuccess={this.state.resendSuccess}
          userEnteredValue={this.props.twoFactorAuthentication.userEnteredValue} changeFlag={this.props.twoFactorAuthentication.changeFlag} resendCodeHandler={this.resendCodeHandler} phoneType={this.state.phoneType} phoneTypeHandler={this.phoneTypeHandler} verifyCodeHandler={this.verifyCodeHandler} invalidCodeError={this.state.invalidCodeError} />;
      case "stepThree":
        return <ConfirmationPopup isEmail={this.props.twoFactorAuthentication.isEmail} handleCloseClick={this.props.handleCloseClick} />;
      /* Sonar Cube fix 
          Done by : Keerthi VL
          Date : 23-01-2023
      */
      default:
        return <PhoneStepOne sendCodeHandler={this.sendCodeHandler} userEnteredValue={this.props.twoFactorAuthentication.userEnteredValue} disableSendCodeBtn={this.state.disableSendCodeBtn}  />;
    }
  };
  render() {
    const view = this.props.twoFactorAuthentication.isEmail ? this.getToEmailView() : this.getToPhoneView();
    return (
      <FocusTrap>
      <div>
        <div className={classes.sceOverlay}>
          <div className={classes.sceOverlayContent}>
            <div className={this.state.currentStep==="stepTwo" ? classes.sceDialogBox :`${classes.sceDialogBox} ${classes.centering}`}>
              <div className={this.state.currentStep==="stepTwo" ?classes.closeIconPaddingStepTwo:classes.closeIconPadding}><button className={classes.iconClose} ><img src={this.closeIcon} onClick={this.props.handleCloseClick} alt="Close Icon" /></button></div>
              <div className={classes.verifyPhone}>
                  {view}
              </div>
            </div>
          </div>
        </div>
      </div>
      </FocusTrap>
    );
  }
}

export default TwoFactorAuthContainer;



